import { Button, Stack } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import * as React from "react";
import ButtonGroup from "../../../components/Buttons/ButtonGroup";
import strings from "../../../config/localization";

interface Resource {
  id: string;
  resourceTypeId: string;
  resourceTypeName: string;
  extSerialNo: string;
}

interface Props {
  resources: Resource[];
  onSubmitHandler: (resources: Resource[]) => void;
  state: boolean;
}

export default function SelectResources(props: Props) {
  const [selectedResources, setSelectedResources] = React.useState<Resource[]>(
    [],
  );

  const columns: ColumnsType<Resource> = [
    {
      title: strings.resourceType,
      dataIndex: "resourceTypeName",
      key: "resourceTypeName",
    },
    {
      title: strings.extSerialNo,
      dataIndex: "externalSerialNo",
      key: "externalSerialNo",
    },
  ];

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: Resource[]) => {
      console.log(
        `selectedRowKeys: ${selectedRowKeys}`,
        "selectedRows: ",
        selectedRows,
      );
      setSelectedResources([...selectedRows]);
    },
    getCheckboxProps: (record: Resource) => ({
      disabled: record.resourceTypeName === "Disabled User", // Column configuration not to be checked
      name: record.resourceTypeName,
    }),
  };

  return (
    <div>
      <Dialog open={props.state} fullWidth>
        <DialogTitle id="alert-dialog-title">
          {strings.selectResource}
        </DialogTitle>
        <DialogContent>
          <Stack spacing={2}>
            <Table
              virtual
              scroll={{ y: 300 }}
              columns={columns}
              dataSource={props.resources}
              pagination={false}
              rowKey="id"
              rowSelection={{
                type: "checkbox",
                ...rowSelection,
              }}
            />
            <ButtonGroup>
              <Button
                variant="contained"
                onClick={() => {
                  props.onSubmitHandler(selectedResources);
                }}
              >
                {strings.select}
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  props.onSubmitHandler([]);
                }}
              >
                {strings.cancel}
              </Button>
            </ButtonGroup>
          </Stack>
        </DialogContent>
      </Dialog>
    </div>
  );
}
